import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty, cloneDeep } from 'lodash';

import '../scss/index.scss';
import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import { newRate } from '@tool/index';
import PDF from '../../../component/pdf';
import Title from '../../../component/title';
import HeadPdf from '../../../component/head-pdf';
import FootPdf from '../../../component/foot-pdf';
import moIndex from '../../../store/index';
import moSalaryIndustry from './store';
import Empty from '@comp/empty/index';
import moUser from '@store/user';
import Chart from './chart';
import IndicatorTable from '../../indicator-table';

interface IProps {}
interface IState {}

const SalaryIndustryPDF = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { industry } = moIndex;
  const {
    xData, yData, labels,
    tableHead, tableLeft, tableRight,
  } = moSalaryIndustry;
  const { isMock } = moIndex;
  const descArr = ['统计说明：在相同行业、城市组合下，计算各职能月度薪酬的中位数，然后计算月度薪酬的同比变化率，最后计算各统计周期下的变化率均值，即为涨薪率', '*此处为不区分城市的涨薪率'];

  useEffect(() => {
    return () => {};
  }, []);

  const pdfLog = () => {
    const newData: any[] = cloneDeep(moSalaryIndustry.xData.slice(5));
    const text: any[] = [];
    for (let i = 0; i < Math.ceil(newData.length / 10); i += 1) {
      const firstData = newData.slice(5 * i + 5 * i, 5 * i + 5 * i + 5);
      const secondData = newData.slice(5 * i + 5 * i + 5, 5 * i + 5 * i + 10);

      text.push(
        <PDF key={i}>
          <section className="salary-up-pdf_1010">
            <HeadPdf onetitle="人力资源核心指标" twotitle={industry.name} />
            <section className="content-salary-1001">
              <section className="title-1001">
                <Title title="涨薪率 - 按行业" bigTitle="人力指标" />
              </section>
              <section className="salary-up_1010" style={{ marginTop: 0 }}>
                {!isEmpty(xData) ? (
                  <section className="salary-up-box-1100">
                    <section className={[
                      'box-13', !isMock ? '' : 'mock-100',
                    ].join(' ')}
                    style={{ overflowY: 'auto' }}>
                      <section className="chart-title_03">
                        {labels.map((item: any, idx: number) => (
                          <p key={idx} className="line-03">
                            <strong>{newRate(item?.change_rate)}</strong>
                            <span>{item?.date}{item?.industry_lv1}涨薪率</span>
                          </p>
                        ))}
                      </section>
                      <section>
                        {!isEmpty(firstData) ? (
                          <Chart height={300} idx={i + 1} index={1}
                            xData={firstData} yData={yData} />
                        ) : null}
                        {!isEmpty(secondData) ? (
                          <Chart height={300} idx={i + 1} index={2}
                            xData={secondData} yData={yData} />
                        ) : null}
                      </section>
                    </section>
                  </section>
                ) : (<Empty padding="50px 0" />)}
              </section>
            </section>
            <FootPdf />
          </section>
        </PDF>,
      );
    }
    return text;
  };

  return (
    <>
      <PDF>
        <section className="salary-up-pdf_1010">
          <HeadPdf onetitle="人力资源核心指标" twotitle={industry.name} />
          <section className="content-salary-1001">
            <section className="title-1001">
              <Title title="涨薪率 - 按行业" bigTitle="人力指标" />
            </section>

            <section className="salary-up_1010">
              <p className="one-13 one-166" style={{ color: '#878787' }}>
                {descArr.map((text: any, ix: number) => (
                  <span key={ix}>{text}</span>
                ))}
              </p>
              {!isEmpty(xData) ? (
                <section className="salary-up-box-1100">
                  <section className={[
                    'box-13', !isMock ? '' : 'mock-100',
                  ].join(' ')}
                  style={{ overflowY: 'auto' }}>
                    <section className="chart-title_03">
                      {labels.map((item: any, idx: number) => (
                        <p key={idx} className="line-03">
                          <strong>{newRate(item?.change_rate)}</strong>
                          <span>{item?.date}{item?.industry_lv1}涨薪率</span>
                        </p>
                      ))}
                    </section>
                    <Chart height={300} idx={0} index={0}
                      xData={xData.slice(0, 5)} yData={yData} />
                  </section>
                </section>
              ) : (<Empty padding="50px 0" />)}
            </section>

            {(xData.length <= 5 && xData.length > 0) ? (
              <IndicatorTable type="行业" tableHead={tableHead}
                tableLeft={tableLeft.slice(0, 27)} tableRight={tableRight.slice(0, 27)} />
            ) : null}
          </section>
          <FootPdf />
        </section>
      </PDF>

      {xData.length > 5 ? pdfLog() : null}
    </>
  );
};

export default observer(SalaryIndustryPDF);
